import type { SVGProps } from 'react';
import * as React from 'react';
import { forwardRef, Ref } from 'react';

const SvgHeart = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 16 16"
    ref={ref}
    {...props}
  >
    <path
      fill="#707070"
      d="M11.125 2.5c-1.29 0-2.42.555-3.125 1.493C7.296 3.055 6.166 2.5 4.875 2.5A3.88 3.88 0 0 0 1 6.375c0 4.375 6.487 7.916 6.763 8.063a.5.5 0 0 0 .474 0C8.513 14.29 15 10.75 15 6.374A3.88 3.88 0 0 0 11.125 2.5M8 13.425c-1.141-.665-6-3.694-6-7.05A2.88 2.88 0 0 1 4.875 3.5c1.216 0 2.236.648 2.662 1.688a.5.5 0 0 0 .926 0C8.889 4.146 9.909 3.5 11.125 3.5A2.88 2.88 0 0 1 14 6.375c0 3.35-4.86 6.384-6 7.05"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgHeart);
export default ForwardRef;
